<template>
  <div style="width: 100%;">
    <v-chip-group
      v-model="selectedGroupId"
      show-arrows
      mandatory
      active-class="primary--text"
    >
      <v-chip
        v-for="group in groups"
        :key="group.id"
        :value="group.id"
      >
        {{ $chPtObjData('chinGroupName', group) }}
        <v-avatar
          v-if="showCount"
          right
          class="darken-2"
        >
          {{ group.itemCount }}
        </v-avatar>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<style scoped>
  ::v-deep .v-slide-group--is-overflowing {
    margin-left: -16px;
    max-width: calc(100% + 32px);
  }
</style>

<script>
import staffSettingApi from '@/api/hr/staffSetting'
import workflowApi from '@/api/workflow/workflow'

export default {
  components: {
  },
  props: {
    businessCode: {
      type: String,
      required: true
    },
    currGroupId: {
      type: Number,
      default: null
    },
    showCount: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectedGroupId: null,
      groups: []
    }
  },
  watch: {
    groups: function (val) {
      this.refreshCnt()
    },
    selectedGroupId: function (val) {
      this.$emit('update:currGroupId', val)
    }
  },
  created () {
    this.onCreate()
  },
  methods: {
    onCreate () {
      if (this.currGroupId) {
        this.selectedGroupId = this.currGroupId
      }
      staffSettingApi.getActiveEntityGroupByEUID(cb => {
        if (cb.status === 201 || cb.status === 200) {
          this.groups = cb.data
        }
      })
    },
    refreshCnt () {
      if (this.showCount) {
        this.groups.forEach(group => {
          workflowApi.countGroupActiveWorkItems(resp => {
            if (resp.status === 201 || resp.status === 200) {
              this.$set(group, 'itemCount', resp.data)
            }
          }, this.businessCode, group.id)
        })
      }
    }
  }
}
</script>
